import { BrowserRouter } from 'react-router-dom';
import { useNotificationStore } from '@lib/store';
import { useSession } from '@shared/hook';
import { Root } from './routes';
import clsx from 'clsx';

export const App = () => {
  const notificationStore = useNotificationStore();

  useSession();

  return (
    <BrowserRouter>
      {notificationStore?.notification?.message && (
        <div>
          <div
            className={clsx(
              `fixed top-0 left-0 z-[1600] flex min-h-[54px] w-full items-center justify-center px-10 shadow-[12px_12px_24px_0_rgba(0,0,0,0.23)]`,
              notificationStore?.notification.type === 'error' ? '!bg-[#e42d34] text-center' : '',
              notificationStore?.notification.type === 'success' ? 'success !bg-[#929292] text-left' : '',
            )}
          >
            <div className='text-sm font-semibold text-white uppercase not-md:flex-1 not-md:text-xs'>{notificationStore.notification.message}</div>
          </div>
        </div>
      )}
      <Root />
    </BrowserRouter>
  );
};
